import { readActiveOfferFromPackages, resolveDefaultCycle, resolveMemberCardButton } from "./offer";
import { isPaidMemberPackage } from "../trialOffer/constants";
import { resolveTrialCheckout, TrialOfferUnavailableError } from "../trialOffer/resolveTrialOffer";
import { buildTrialGate } from "../trialOffer/trialGate";
import type { MemberPurchaseInput, MemberPurchaseUser } from "./purchase.types";

/** 权益刷新后重算购买意图，持久化缓存或另一个标签页的旧按钮不能决定新订单。 */
export function validateMemberPurchase(input: MemberPurchaseInput, user: MemberPurchaseUser) {
  if (!isPaidMemberPackage(input.key) || input.isBuyout == null) return undefined;
  const trial = resolveTrialCheckout({
    ...buildTrialGate({ packageKey: input.key, monthSubscribe: input.timeMode === "subscribe" && !input.isBuyout }, {
      trialTier: user.sources.trialTier ?? 0,
      highestPackage: user.highestPackage,
      isMemberUser: user.isMemberUser,
      currentActiveTrial: user.sources.currentActiveTrial,
      expiryHistory: user.sources
    }),
    offer: input.trialDeclaration === true ? "trial" : "full"
  });
  if (trial.checkout === "blocked") {
    if (input.trialDeclaration === true) throw new TrialOfferUnavailableError();
    throw new Error("会员权益已更新，请重新选择套餐");
  }
  if (input.trialDeclaration === true) return undefined;
  const button = resolveMemberCardButton({
    version: input.key,
    cycle: resolveDefaultCycle(input.timeMode),
    payMode: input.isBuyout ? "buyout" : "subscribe",
    active: user.isMemberUser ? readActiveOfferFromPackages(user.highestPackage, user.packages) : null
  });
  if (button.disabled) throw new Error("会员权益已更新，请重新选择套餐");
  return button.action;
}
